/** AnalystPanel — Analyst thesis + technicals summary card. */
import { PROP } from "@/constants/testIds";

function StatCell({ label, value, tone, className = "" }) {
  return (
    <div className={`px-3 py-2 ${className}`}>
      <div className="label-cap">{label}</div>
      <div className={`mono text-sm mt-0.5 ${tone === "up" ? "pnl-up" : tone === "down" ? "pnl-down" : ""}`}>{value}</div>
    </div>
  );
}

export default function AnalystPanel({ analyst }) {
  const a = analyst || {};
  return (
    <div className="lg:col-span-3 bg-card p-4 space-y-3" data-testid={PROP.analystCard}>
      <div className="flex items-center gap-2">
        <div className="w-2 h-2 bg-[#0A84FF]" aria-hidden="true"/>
        <div className="label-cap">Trade Analyst</div>
      </div>
      <p className="text-sm leading-relaxed">{a.thesis}</p>
      <div className="grid grid-cols-2 gap-px bg-border/40 text-xs">
        <StatCell label="Trend" value={(a.trend || "-").toUpperCase()} className="bg-card/40"/>
        <StatCell label="Regime" value={(a.regime || "-").toUpperCase()} className="bg-card/40"/>
        <StatCell label="20 SMA" value={a.sma_20 ? `$${a.sma_20}` : "—"} className="bg-card/40"/>
        <StatCell label="50 SMA" value={a.sma_50 ? `$${a.sma_50}` : "—"} className="bg-card/40"/>
      </div>
      <div>
        <div className="label-cap mb-1">Catalysts</div>
        <ul className="text-xs list-disc list-inside space-y-0.5 text-muted-foreground">{(a.catalysts || []).map((x, i) => <li key={i}>{x}</li>)}</ul>
      </div>
      {a.risks?.length ? (
        <div>
          <div className="label-cap mb-1">Risks</div>
          <ul className="text-xs list-disc list-inside space-y-0.5 text-muted-foreground">{a.risks.map((x, i) => <li key={i}>{x}</li>)}</ul>
        </div>
      ) : null}
    </div>
  );
}
